import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1.6 2.4h12.8V8h.8V1.6H.8v13.6H8v-.8H1.6v-12z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M4.4 4V0h.8v4h-.8zm7.2-4v4h-.8V0h.8zM1.2 5.2h13.6V6H1.2v-.8zM12.4 12.4V9.6h.8v2.8H16v.8h-2.8V16h-.8v-2.8H9.6v-.8h2.8z" fill="#000" /></svg>;